import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import {
  createColumn,
  createViewAction,
  formatDateTime,
} from "../../utils/helpers";
import { URL_LINKED_CARS } from "../../utils/urls";

export const useAdvancesLinkedcars = () => {
  const tableColumns = () => [
    createColumn("advance", true, "E-coupon"),
    createColumn("advance_phone_number", true, "Phone Number"),
    createColumn("car_number", true, "Car Number"),
    createColumn("is_active", true, "Is Active"),
    createColumn("created_at", true, "Created At"),
    createColumn("updated_at", true, "Updated At"),
    createColumn("actions", false),
  ];

  const tableData = (data: any) => {
    if (!data) return [];

    return data.map((item: any) => {
      return {
        ...item,
        is_active: <BooleanTags status={item?.is_active} />,
        created_at: item?.created_at ? formatDateTime(item.created_at) : "N/A",
        updated_at: item?.updated_at ? formatDateTime(item.updated_at) : "N/A",
        actions: (
          <FormActions
            actions={[createViewAction(URL_LINKED_CARS, item?.id)]}
          />
        ),
      };
    });
  };

  const viewData = (item: any) => {
    if (!item) {
      return {
        sections: [
          {
            title: "Error",
            fields: {
              message: "No data available",
            },
          },
        ],
      };
    }

    return {
      sections: [
        {
          title: "Linked Car",
          fields: {
            advance: item?.advance,
            advance_phone_number: item?.advance_phone_number,
            car_number: item?.car_number,
            is_active: <BooleanTags status={item?.is_active} />,
            created_at: item?.created_at
              ? formatDateTime(item.created_at)
              : "N/A",
            updated_at: item?.updated_at
              ? formatDateTime(item.updated_at)
              : "N/A",
          },
        },
      ],
    };
  };

  const activityFilter = "advance_car_numbers";

  return {
    tableColumns,
    tableData,
    viewData,
    activityFilter,
  };
};
